(function () {
    var smartFieldsModule = angular.module('harriApp.smartFields', []);

    smartFieldsModule.filter('orderObjectBy', function () {
        return function (items, field, reverse) {
            var filtered = [];

            for (var i in items) {
                filtered.push(items[i]);
            }

            filtered.sort(function (a, b) {
                return (a[field] > b[field] ? 1 : -1);
            });

            if (reverse) filtered.reverse();

            return filtered;
        }
    });
})();